import { createTheme } from '@mui/material/styles';
import '@fontsource/plus-jakarta-sans'; // Defaults to weight 400

// Define the theme, incorporating styles from the other project
const theme = createTheme({
  palette: {
    primary: {
      main: '#000031', // Restoring the darker blue
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#8191a6', // From other project
      contrastText: '#ffffff',
    },
    error: {
      main: '#d12941', // From other project
    },
    warning: {
      main: '#ee6f42', // From other project
    },
    info: {
      main: '#50a1b1', // From other project
    },
    text: {
      primary: '#000031', // From other project
      secondary: '#8191a6', // From other project
    },
    background: {
      default: '#ffffff', // From other project
      paper: '#ffffff', // From other project
    },
    // The default divider color (used for OutlinedInput border) will be calculated by MUI
    // based on the theme type (light/dark). For a light theme, it's 'rgba(0, 0, 0, 0.12)'
    // which should give a light grey border.
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", sans-serif', // Corrected font name from @fontsource
    button: {
      textTransform: 'none', // From other project
      // borderRadius is handled in MuiButton styleOverrides
    }
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'outlined', // Keep our default variant
        // No InputLabelProps shrink: true, to allow floating label
        // No explicit OutlinedInput border override here, let palette and defaults handle it
      },
    },
    MuiButton: {
      defaultProps: {
        // variant: 'contained', // Let specific overrides or usage define variant
        // color: 'primary', // Let specific overrides or usage define color
      },
      styleOverrides: {
        root: {
          borderRadius: '8px', // From other project
          textTransform: 'none', // Ensure this is here as per their typography.button
        },
        containedPrimary: ({ theme }) => ({
          paddingInline: theme.spacing(2),
          paddingBlock:  theme.spacing(1.25),
          fontWeight: 600,
          // keep your existing hover darkening
          '&:hover': { backgroundColor: '#00005a' },
        }),
        outlinedPrimary: ({theme}) => ({
          borderColor: '#00005a', // From other project
          paddingInline: theme.spacing(2),
          paddingBlock:  theme.spacing(1.25),
          color: '#000031', // From other project
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 49, 0.04)', // From other project
            borderColor: '#00005a', // From other project
            color: '#00005a', // From other project
          },
        }),
        // We can add containedSecondary, outlinedSecondary etc. if needed
      },
    },
    // MuiAppBar override removed to allow color="primary" to use palette.primary.main
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none', // From other project
          color: '#000031', // Match primary text color for links by default
          '&:hover': {
            textDecoration: 'underline', // From other project
            color: '#00005a', // Darken on hover
          }
        },
      },
    },
    // MuiOutlinedInput is intentionally left out here for border color
    // to let MUI derive it from the palette, which should result in a light grey.

    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          '&.Mui-disabled': {
            backgroundColor: 'rgba(0,0,49,0.1)',
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        input: {
          '&.Mui-disabled': {
            backgroundColor: 'rgba(0,0,49,0.1)',
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        input: {
          '&.Mui-disabled': {
            backgroundColor: 'rgba(0,0,49,0.1)',
          },
        },
      },
    },
  },
});

export default theme;